// extracted by mini-css-extract-plugin
export default {"videoPlayer":"styles__videoPlayer___YUb32","loaderWrap":"styles__loaderWrap___JQyCU","playBtn":"styles__playBtn___VzIh6"};